import styled from 'styled-components'

export const WhiteWrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  padding: 24px 24px 48px;
`

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 8px 0px 16px;
`

export const FormButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 42px;
  gap: 8px;
`
